<div class="flex flex-justify-between flex-middle bg-col-35 p-l p-r p-t-2 p-b-2 cursor-pointer"
     (click)="removeOOSProducts()"
     tabindex="0"
     role="button"
     [attr.aria-label]="'Remove all out of stock items from bag' | translate">
    <div class="left">
        <p class="s1 center-m center-s">{{'Some items are out of stock, remove to continue' | translate}}</p>
        <p class="p2">
            {{'Click' | translate}}
            <span class="fw-bold">{{' here ' | translate}}</span>
            {{'to remove all out of stock items from bag' | translate}}
        </p>
    </div>
    <i class="icon-trash"
       [style.font-size.px]="32"
       aria-hidden="true"></i>
</div>